import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { faComment, faEnvelope, faUser } from '@fortawesome/pro-duotone-svg-icons';
import { Observable, Subject } from 'rxjs';
import { ChatGuestInfo } from 'src/app/store/samwin/chats/models/chat-guest-info';
import { takeUntil, map, distinctUntilChanged } from 'rxjs/operators';

@Component({
   selector: 'samweb-guest-info',
   templateUrl: './chat-guest-info.component.html',
   styleUrls: ['./chat-guest-info.component.scss'],
})
export class ChatGuestInfoComponent implements OnInit, OnDestroy {
   private destroy$ = new Subject();

   @Input()
   public chatGuestInfo$: Observable<ChatGuestInfo>;
   public guestStatusTranslate$: Observable<string>;

   public chatIcon: IconDefinition = faComment;
   public nameIcon: IconDefinition = faUser;
   public emailIcon: IconDefinition = faEnvelope;

   ngOnInit(): void {
      this.guestStatusTranslate$ = this.chatGuestInfo$.pipe(
         distinctUntilChanged(),
         map((info) => 'samwin.chat_dialog.guest_status.' + info.guestStatus.value),
         takeUntil(this.destroy$)
      );
   }

   ngOnDestroy(): void {
      this.destroy$.next();
      this.destroy$.complete();
   }
}
